/**
 * Prevent default in smile snap buttons.
 */
export const smileSnapButtonsHandle = () => {

	const smileSnapButtons = document.querySelectorAll( '.smilesnap-button .wp-block-button__link' )

	if ( ! smileSnapButtons ) {

		return

	}

	smileSnapButtons.forEach( ( button ) => {

		button.addEventListener( 'click', ( e ) => {

			e.preventDefault()

		} )

	} )

}
